const commonAndMisc = {
  errorMessage404: "Ουπς! Η σελίδα που ψάχνετε δεν υπάρχει", // translated
  errorContentUnavailable: "Ουπς! Το περιεχόμενο που αναζητάτε δεν υπάρχει. Επικοινωνήστε μαζί μας για το πρόβλημα", // translated
  backToHome: "Πίσω στο σπίτι", // translated
  information: "Πληροφορίες", // translated
  additionalInformation: "Επιπλέον πληροφορίες", // translated
  destinationPlaceholder: "Πού πηγαίνεις", // translated
  aboutUs: "Σχετικά με εμάς", // translated
  pleaseWait: "Παρακαλώ περιμένετε...", // translated
  featuredHotels: "Επιλεγμένα ξενοδοχεία", // translated
  topPackages: "Κορυφαία πακέτα", // translated
  topTours: "Κορυφαίες εκδρομές", // translated
  traveller: "Ταξιδιώτης", // translated
  reviews: "Κριτικές", // translated
  home: "Σπίτι", // translated
  packages: "Πακέτα", // translated
  experiences: "Εμπειρίες", // translated
  close: "Κλείσε", // translated
  loadingMessage: "Περιμένετε όσο αναζητούμε τις καλύτερες διαθέσιμες τιμές", // translated
  loadingMessageTheHotelCo: "Περιμένετε όσο αναζητούμε τις καλύτερες διαθέσιμες τιμές", // translated
  loadingMessageSearchStrip: "Περιμένετε μέχρι να αναζητήσουμε τις καλύτερες διαθέσιμες τιμές...", // translated
  topCountriesToVisit: "Κορυφαίες χώρες για επίσκεψη", // translated
  profile: "Προφίλ", // translated
  reservations: "κρατήσεις", // translated
  address: "Διεύθυνση", // translated
  firstName: "Ονομα", // translated
  lastName: "Επίθετο", // translated
  email: "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ", // translated
  login: "Σύνδεση", // translated
  logout: "Αποσύνδεση", // translated
  myProfile: "Το ΠΡΟΦΙΛ μου", // translated
  myChatRooms: "Οι συνομιλίες μου", // translated 
  chatRoomsListEmpty: "Δεν έχετε αίθουσες συνομιλίας για αυτόν τον λογαριασμό.", // translated 
  chatRoomsOpen: "Ανοιχτό", // translated 
  chatRoomsLastActivity: "Τελευταία δραστηριότητα", // translated 
  chatRoomsUnread: "Αδιάβαστος", // translated 
  chatRoomsBadgeQuotation: "Προσφορά", // translated 
  chatRoomsBadgeTripOffer: "Προσφορά ταξιδιού", // translated 
  chatRoomsOpenQuotationAria: "Άνοιγμα συνομιλίας προσφοράς: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "Άνοιγμα συνομιλίας προσφοράς ταξιδιού: {{name}}", // translated 
  chatRoomsOpenGenericAria: "Άνοιγμα συνομιλίας: {{name}}", // translated 
  quotationChatInvalidLink:
    "Μη έγκυρος σύνδεσμος συνομιλίας. Ανοίξτε μια συνομιλία από το προφίλ σας ή τη λίστα προσφορών, ή χρησιμοποιήστε ακριβώς ένα από room_code ή room_uid.", // translated 
  quotationChatNoTripDetails: "Οι λεπτομέρειες του ταξιδιού δεν είναι διαθέσιμες για αυτή τη συνομιλία.", // translated 
  chat: "Κουβέντα", // translated 
  verified: "Επαληθεύτηκε", // translated
  unverified: "Ανεπιβεβαίωτος", // translated
  selectLanguage: "Επιλέξτε γλώσσα", // translated
  selectCurrency: "Επιλέξτε νόμισμα", // translated
  upgrade: "Αναβαθμίζω", // translated
  membership: "Ιδιότητα μέλους", // translated
  travelTrust: "Travel Trust", // translated
  signInUp: "Είσοδος/Εγγραφή", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates: "ξενοδοχεία και θέρετρα σε όλο τον κόσμο σε εκπληκτικές τιμές χονδρικής", // translated
  dashboard: "Ταμπλό", // translated
  pricing: "Τιμολόγηση", // translated
  refundable: "Με δυνατότητα επιστροφής χρημάτων", // translated
  cars: "Αυτοκίνητα", // translated
  cruises: "Κρουαζιέρες", // translated
  view: "Θέα", // translated
  price: "Τιμή", // translated
  totalPrice: "Συνολικό ποσό", // translated
  filterRoomName: "Φιλτράρισμα ονόματος δωματίου", // translated
  get: "Παίρνω", // translated
  guestInformationValidation: "Επικύρωση πληροφοριών επισκεπτών", // translated
  reservation: "Κράτηση", // translated
  checkIn: "Ελεγχος εισιτηρίου", // translated
  checkOut: "Ολοκλήρωση αγοράς", // translated
  paymentInitiattionErroeMessage: "Δεν μπορέσαμε να ξεκινήσουμε τη διαδικασία πληρωμής σας. Ζητούμε συγνώμη για την αναστάτωση", // translated
  warning: "Προειδοποίηση", // translated
  couldNotFindPriceForDateWarning: "Δεν μπορέσαμε να βρούμε τιμή για αυτήν την ημερομηνία. Δοκιμάστε ξανά για διαφορετική ημερομηνία", // translated
  searchFormValidationError: "Σφάλμα επικύρωσης φόρμας αναζήτησης", // translated
  pleaseSelectValidDateFirst: "Επιλέξτε πρώτα μια έγκυρη ημερομηνία", // translated
  searchError: "Σφάλμα αναζήτησης", // translated
  priceSearchInitiationError: "Δεν μπορέσαμε να ξεκινήσουμε τη διαδικασία αναζήτησης τιμής. Παρακαλώ δοκιμάστε ξανά αργότερα. Ζητούμε συγνώμη για την αναστάτωση", // translated
  searchWarning: "Προειδοποίηση αναζήτησης", // translated
  couldNotFindPriceAndOrAvailability: "Δεν μπορέσαμε να βρούμε τιμή ή/και διαθεσιμότητα για το αίτημά σας. Ζητούμε συγνώμη για την αναστάτωση", // translated
  joinNow: "Πάρε μέρος τώρα", // translated
  signIn: "Συνδεθείτε", // translated
  searchNow: "Ψάξε τώρα", // translated
  bookingFailed: "Η κράτηση απέτυχε", // translated
  sorryForTheInconvenience: "Ζητούμε συγνώμη για την αναστάτωση", // translated
  paymentFailedTryAgain: "Η πληρωμή απέτυχε. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα", // translated
  quickLinks: "Γρήγοροι Σύνδεσμοι", // translated
  tours: "Περιηγήσεις", // translated
  termsAndConditions: "Οροι και Προϋποθέσεις", // translated
  pleaseWaitWhileInitiatingPayment: "Περιμένετε μέχρι να ξεκινήσουμε τη διαδικασία πληρωμής σας", // translated
  back: "Πίσω", // translated
  nextStep: "Επόμενο βήμα", // translated
  book: "Βιβλίο", // translated
  checkout: "Ολοκλήρωση αγοράς", // translated
  specifyPickUpPoint: "Καθορίστε το σημείο της παραλαβής που προτιμάτε", // translated
  pickupPoint: "Σημείο παραλαβής", // translated
  optional: "προαιρετικός", // translated
  remarks: "Παρατηρήσεις", // translated
  travellerInformation: "Πληροφορίες ταξιδιωτών", // translated
  bookingRemarks: "Παρατηρήσεις κράτησης", // translated
  bookingOverview: "Επισκόπηση κρατήσεων", // translated
  paymentFailed: "Η πληρωμή απέτυχε", // translated
  paymentSuccess: "Επιτυχία πληρωμής", // translated
  at: "Στο", // translated
  person: "πρόσωπο", // translated
  cancellationPolicy: "Πολιτική ακύρωσης", // translated
  From: "Από", // translated
  to: "Προς την", // translated
  cancellationIs: "ακύρωση είναι", // translated
  pickup: "Μαζεύω", // translated
  flights: "Πτήσεις", // translated
  Accommodation: "Κατάλυμα", // translated
  payAndBook: "Pay & Book", // translated
  onRequest: "Κατόπιν αίτησης", // translated
  weAreFindingTheBestAvailableServices: "Βρίσκουμε τις καλύτερες διαθέσιμες υπηρεσίες", // translated
  withTheBestAvailablePrices: "με τις καλύτερες διαθέσιμες τιμές", // translated
  inRealTime: "σε πραγματικό χρόνο", // translated
  seconds: "δευτερόλεπτα", // translated
  thisProcessCanTakeUpToOneMinute: "Αυτή η διαδικασία μπορεί να διαρκέσει έως και 1 λεπτό", // translated
  pleaseDoNotRefreshThisPage: "Μην ανανεώνετε αυτήν τη σελίδα", // translated
  wellItSeemsItCanTakeBitLonger: "Λοιπόν... φαίνεται ότι μπορεί να διαρκέσει λίγο περισσότερο", // translated
  yourBrowserDoesNotSupportTheVideoTag: "Το πρόγραμμα περιήγησής σας δεν υποστηρίζει την ετικέτα βίντεο", // translated
  bookingSuccess: "Επιτυχία κράτησης", // translated
  bookingReference: "Αναφορά κράτησης", // translated
  referenceCopied: "Η αναφορά αντιγράφηκε", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation: "Σύντομα, θα λάβετε ένα email που θα περιέχει όλες τις απαραίτητες πληροφορίες για την κράτησή σας", // translated
  viewMore: "Δείτε περισσότερα", // translated
  readMore: "Διαβάστε περισσότερα", // translated
  customerSupport: "Υποστήριξη πελατών", // translated
  socialMedia: "Μεσα ΚΟΙΝΩΝΙΚΗΣ ΔΙΚΤΥΩΣΗΣ", // translated
  hours: "ώρες", // translated
  hour: "ώρα", // translated
  minutes: "λεπτά", // translated
  minute: "λεπτό", // translated
  memberId: "ταυτότητα μέλους", // translated
  star: "Αστέρι", // translated
  stars: "αστέρια", // translated
  proceed: "Προχωρώ", // translated
  clearAllFilters: "Διαγράψτε όλα τα φίλτρα", // translated
  clearYourFilters: "Διαγράψτε τις επιλογές φίλτρου για να δείτε τα αποτελέσματα", // translated
  noOptionsForSelectedFilters: "Δεν υπάρχουν διαθέσιμες επιλογές για την αντιστοίχιση των φίλτρων σας", // translated
  privacyPolicy: "Πολιτική Απορρήτου", // translated
  security: "Ασφάλεια", // translated
  nearby: "Πλησίον", // translated
  distanceFromSelection: "Απόσταση από την επιλογή", // translated
  km: "χλμ", // translated
  restaurants: "Εστιατόρια", // translated
  active: "Ενεργός", // translated
  visitSite: "Επισκεφθείτε την ιστοσελίδα", // translated
  score: "Σκορ", // translated
  applicationAvailable: "διαθέσιμη εφαρμογή", // translated
  sendUsEmail: "Στείλτε μας ένα email", // translated
  sendUsYourRequest: "Στείλτε μας το αίτημά σας", // translated
  notAvailable: "Μη διαθέσιμος", // translated
  found: "Βρέθηκαν", // translated
  progressAt: "Πρόοδος στο", // translated
  currency: "Νόμισμα", // translated
  sendUsRequest: "Στείλτε μας το αίτημά σας", // translated
  noReservationsForThisProduct: "Δεν υπάρχουν κρατήσεις για αυτό το προϊόν", // translated
  confirmed: "Επιβεβαιωμένος", // translated
  cancelled: "Ακυρώθηκε", // translated
  pending: "εκκρεμής", // translated
  status: "Κατάσταση", // translated
  reference: "Αναφορά", // translated
  leadGuest: "Κύριος Επισκέπτης", // translated
  sendVoucherEmail: "Αποστολή κουπονιού email", // translated
  sendCancellationEmail: "Αποστολή email ακύρωσης", // translated
  downloadVoucher: "Λήψη κουπονιού", // translated
  emailHasBeenSent: "Το email εστάλη με επιτυχία", // translated
  emailNotSentTryAgain: "Το email δεν στάλθηκε! ΠΑΡΑΚΑΛΩ προσπαθησε ξανα", // translated
  titleIsRequired: "Απαιτείται τίτλος", // translated
  genderIsRequired: "Το φύλο είναι υποχρεωτικό", // translated
  firstNameMustContainAlphabetic: "Το όνομα πρέπει να περιέχει μόνο αλφαβητικούς χαρακτήρες", // translated
  firstNameIsRequired: "Το όνομα είναι υποχρεωτικό", // translated
  lastNameIsRequired: "Το επώνυμο είναι υποχρεωτικό", // translated
  lastNameMustContainAlphabetic: "Το επώνυμο πρέπει να περιέχει μόνο αλφαβητικούς χαρακτήρες", // translated
  phoneNumberInTheFormat: "Ο αριθμός τηλεφώνου πρέπει να έχει τη μορφή χωρίς κενά", // translated
  phoneNumberIsRequired: "Απαιτείται αριθμός τηλεφώνου", // translated
  emailIsRequired: "Απαιτείται email", // translated
  invalidEmail: "Ακυρη διεύθυνση ηλεκτρονικού ταχυδρομείου", // translated
  addressIsRequired: "Απαιτείται διεύθυνση", // translated
  cityIsRequired: "Η πόλη είναι απαραίτητη", // translated
  postalCodeIsRequired: "Απαιτείται ταχυδρομικός κώδικας", // translated
  countryIsRequired: "Απαιτείται χώρα", // translated
  yourReservationIsInProgress: "Η κράτησή σας είναι σε εξέλιξη", // translated
  clickHere: "Κάντε κλικ ΕΔΩ", // translated
  iHaveReadAgreeWithAbove: "Έχω διαβάσει και συμφωνώ με τα παραπάνω", // translated
  pleaseCheckTheBox: "Επιλέξτε το πλαίσιο για να υποδείξετε ότι έχετε διαβάσει και συμφωνείτε με τις παρεχόμενες πληροφορίες προτού προχωρήσετε στο επόμενο βήμα.", // translated
  myPoints: "Τα σημεία μου", // translated
  maintenanceTitle: "Η ιστοσελίδα είναι υπό συντήρηση", // translated 
  maintenanceDescription:
    "Πραγματοποιούμε προγραμματισμένη συντήρηση. Παρακαλούμε επιστρέψτε σύντομα.", // translated 
  maintenanceCountdownLabel: "Εκτιμώμενος χρόνος που απομένει", // translated 
  maintenanceLogoAlt: "Λογότυπο ιστοσελίδας", // translated 
  maintenanceDays: "Ημέρα", // translated 
  maintenanceHours: "Όρες", // translated 
  maintenanceMinutes: "Λεπτά", // translated 
  maintenanceSeconds: "Δευτερολέπτα", // translated 
  maintenanceStatusBadge: "Προγραμματισμένη συντήρηση", // translated 
  maintenanceRefresh: "Ανανέωση σελίδας", // translated 
  maintenanceExpired:
    "Η συντήρηση θα πρέπει να ολοκληρωθεί σύντομα. Παρακαλούμε ανανεώστε τη σελίδα.", // translated 
};


export default commonAndMisc;
